import { useCallback } from 'react'
import type { MutationHook } from '@commerce/utils/types'
import { CommerceError } from '@commerce/utils/errors'
import useForgotPassword, { UseForgotPassword } from '@commerce/auth/use-forgotPassword'
import type { ForgotPasswordHook } from '../types/forgotPassword'
import useCustomer from '../customer/use-customer'

import {
  setCustomerToken,
  throwUserErrors,
  customerRecoverMutation,
} from '../utils'
import { Mutation, MutationCustomerRecoverArgs } from '../schema'

export default useForgotPassword as UseForgotPassword<typeof handler>

export const handler: MutationHook<ForgotPasswordHook> = {
  fetchOptions: {
    query: customerRecoverMutation,
  },
  async fetcher({ input: { email }, options, fetch }) {
    if (!(email)) {
      throw new CommerceError({
        message:
          'An email is required to recover password',
      })
    }

    const { customerRecover } = await fetch<
      Mutation,
      MutationCustomerRecoverArgs
    >({
      ...options,
      variables: {
        input: email,
      },
    })

    throwUserErrors(customerRecover?.customerUserErrors)

    return null
  },
  useHook: ({ fetch }) => () => {
    const { mutate } = useCustomer()

    return useCallback(
      async function forgotPassword(input) {
        const data = await fetch({ input })
        await mutate()
        return data
      },
      [fetch, mutate]
    )
  },
}
